import * as dto from '@epicuro-next/data/baskets-dto';
import { Maybe } from 'graphql-api/baskets-api-interfaces';

/**
 * Groups items by address.
 */
export function groupItemsByAddress(
  items: dto.Item[],
  deliveryMap: dto.DeliveryAddressMap,
) {
  return items.reduce((result, item) => {
    const address = deliveryMap[item.deliveryId];

    return {
      ...result,
      [address.addressId]: [...(result[address.addressId] || []), item],
    };
  }, {} as { [addressId: string]: dto.Item[] });
}

function mapAlternativeAddress(
  alternativeAddress: Maybe<dto.AlternativeAddress>,
) {
  return alternativeAddress
    ? {
        ...alternativeAddress,
        country: alternativeAddress?.country?.toUpperCase(),
      }
    : null;
}

/**
 * Create map of delivery id to address.
 */
export function getDeliveryAddressMap(
  basketAccounts: dto.BasketAccount[],
): dto.DeliveryAddressMap {
  return basketAccounts
    .flatMap((basketAccount) => {
      const alternativeStreet = `${
        basketAccount.alternativeAddress?.street1 || ''
      } ${basketAccount.alternativeAddress?.street2 || ''}`;

      const alternativeStreetTrimmed = alternativeStreet.replace(/^[ .]+/g, '');

      return basketAccount.deliveries.map((delivery) => ({
        delivery,
        address: {
          ...(mapAlternativeAddress(basketAccount.alternativeAddress) ||
            basketAccount.address),
          name:
            basketAccount.alternativeAddress?.name ||
            basketAccount.address?.name ||
            basketAccount.account?.name,
          street: alternativeStreetTrimmed || basketAccount.address?.street,
        },
      }));
    })
    .reduce(
      (result, item) => ({
        ...result,
        [item.delivery.deliveryId]: item.address,
      }),
      {},
    );
}

/**
 * Creates map of address id to address.
 */
export function getAddressMap(deliveryMap: dto.DeliveryAddressMap) {
  return Object.keys(deliveryMap).reduce((result, deliveryId) => {
    const address = deliveryMap[deliveryId];

    return {
      ...result,
      [address.addressId]: address,
    };
  }, {} as dto.AddressMap);
}
